import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardWrapper,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ApplyExclusiveMultiSelectOption } from 'Helpers/ExclusiveMultiSelect';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  ApplyExclusiveMultiSelectOption(resource, 'choices');

  const stepHasQuestion = resource.attr('choice') !== undefined || resource.attr('choices') !== undefined;
  const questionNotAnswered = !resource.attr('choices')?.length && !resource.attr('choice');

  return (
    <TaxDashboardWizardWrapper continueDisabled={stepHasQuestion && questionNotAnswered}>
      <FDStack direction="column" spacing={2}>
        <MetaControlField attr={'body'} {...dataAttrs('dashboard-review-kickoff-wizard-body')} />
        <MetaControlField attr={'questionText'} {...dataAttrs('dashboard-review-kickoff-wizard-question-text')} />

        {/* Question Answer Options */}
        <MetaControlField attr={'choices'} {...dataAttrs('dashboard-review-current-year-opportunities-choices')} />
        <MetaControlField attr={'choice'} {...dataAttrs('dashboard-review-current-year-opportunities-choice')} />

        {/* Disclosure */}
        <MetaControlField attr={'disclosure'} {...dataAttrs('dashboard-review-wizard-disclosure')} />
        <MetaControlField attr={'externalDisclosure'} {...dataAttrs('dashboard-review-wizard-external-disclosure')} />
        <MetaControlField attr={'partnerDisclosure'} {...dataAttrs('dashboard-review-wizard-partner-disclosure')} />

        <MetaControlField attr={'plannerAlert'} {...dataAttrs('dashboard-review-wizard-planner-alert')} />
        <MetaControlField attr={'marriageMismatchAlert'} {...dataAttrs('dashboard-review-wizard-marriage-mismatch-alert')} />
      </FDStack>
    </TaxDashboardWizardWrapper>
  );
};

export default Layout;
